module.exports = __webpack_public_path__ + "img/programs-icon-2.e8739a3b.png";